import { H1 } from '@atoms/Typographies';
import { useCloseRequestList } from '@hooks/Services';
import { CsvDownloadClose } from '@organisms/GenesisEs/Csv';
import { CloseForm } from '@organisms/GenesisEs/Forms';
import { CloseFormType } from '@organisms/GenesisEs/Forms/CloseFormType';
import { Container } from '@organisms/GenesisEs/Layouts';
import { CloseTableList } from '@organisms/GenesisEs/List';
import Head from '@organisms/Heads/Head';
import { Storage } from '@states/Storage';
import CommonTemplate from '@templates/Common';
import React, { useState } from 'react';
import styled from 'styled-components';


const List = () => {
    const [searchParams, setSearchParams] = useState<CloseFormType>(Storage.get(Storage.keys.GENESISES_CLOSELIST));
    const closeRequestList = useCloseRequestList.useAllListData(searchParams);
    const SubmitHandler = (data: CloseFormType) => {
        setSearchParams(data);
    }
    return (
        <CommonTemplate>
            <Head title="廃止申込結果一覧" />

            <ListWithStyled>
                <HeadingWithStyled className="mb-4">
                    <H1>廃止申込結果一覧</H1>
                </HeadingWithStyled>
                <Container title='Search' children={<CloseForm submitHandler={SubmitHandler} />} />
                <Container title='Result' children={<CloseTableList listData={closeRequestList} />} headerButton={
                    <ButtonGroupWithStyled>
                        <CsvDownloadClose listData={closeRequestList} />
                    </ButtonGroupWithStyled>
                } />
            </ListWithStyled>

        </CommonTemplate>
    );
};

const HeadingWithStyled = styled.div`
`
const ButtonGroupWithStyled = styled.div`
    & > div {
        display: inline-block;
        margin-left: 4px;
        & .btn-sm {
            font-size: 12px;
        }
    }
`
const ListWithStyled = styled.div`
`

export default List;